module.exports = __webpack_public_path__ + "img/375 tarif.823bbeb.jpg";